<template>
  <div class="login__form">
    <h1>Regístrate</h1>

    <form class="register__form" @submit.prevent="submitV2">
      <div class="register__form--first-step">
        <div class="input-box">
          <label>
            <input type="radio" value="juridica" v-model="personType" />
            Empresas
          </label>
        </div>

        <div class="input-box">
          <label>
            <input type="radio" value="natural" v-model="personType" />
            Particulares
          </label>
        </div>

        <!-- Solo para JURÍDICA -->
        <template v-if="personType === 'juridica'">
          <div class="input-box">
            <label>Nombre de empresa*</label>
            <input
              type="text"
              name="company_name"
              id="company_name"
              v-model.trim="company.company_name"
              placeholder=""
            />
          </div>

          <div class="input-box">
            <label>RUC*</label>
            <input
              type="text"
              name="ruc"
              id="ruc"
              maxlength="11"
              v-model.trim="company.ruc"
              @input="
                company.ruc = company.ruc.replace(/\\D+/g, '').slice(0, 11)
              "
              placeholder=""
            />
          </div>
        </template>

        <div class="input-box">
          <label>Nombre*</label>
          <input type="text" name="name" id="name" v-model="form.name" />
        </div>

        <div class="input-box">
          <label>Apellido*</label>
          <input
            type="text"
            name="last_name"
            id="last_name"
            v-model="form.last_name"
          />
        </div>

        <div class="input-box">
          <label>Email*</label>
          <input type="email" name="email" id="email" v-model="form.email" />
        </div>

        <div class="input-box">
          <label>Teléfono*</label>
          <input type="tel" name="phone" id="phone" v-model="form.phone" />
        </div>

        <div class="input-box input-box--full">
          <label>Contraseña*</label>
          <input
            type="password"
            name="password"
            id="password"
            v-model="form.password"
          />
        </div>

        <div class="input-box input-box--full">
          <label>Repetir contraseña*</label>
          <input
            type="password"
            name="password_confirmation"
            id="password_confirmation"
            v-model="form.password_confirmation"
          />
          <ul class="rule">
            <li>La contraseña debe contener al menos 6 caracteres.</li>
            <li>Se aceptan caracteres alfanuméricos y símbolos.</li>
          </ul>
        </div>

        <div class="input-box input-checkbox input-box--full">
          <label for="term_conditions">
            <input
              type="checkbox"
              name="term_conditions"
              id="term_conditions"
              v-model="form.term_conditions"
            />
            Acepto los
            <a :href="url_term_conditions" target="_blank"
              >Términos y Condiciones</a
            >.
          </label>
        </div>

        <div class="input-box input-buttons input-box--full mt-4">
          <button type="submit" class="btn btn--blue w-100">Registrarme</button>
        </div>

        <div class="input-box input-box--full login-message">
          ¿Ya tienes una cuenta?
          <a :href="url_login">Inicia sesión</a>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from 'axios'
import { reactive, ref } from 'vue'
import { customAlert } from '@general/js/utils/swalMessages'

export default {
  name: 'RegisterV2',
  props: {
    url_signup: { type: String, default: '' },
    url_signin: { type: String, default: '' },
    url_term_conditions: { type: String, default: '' },
    url_login: { type: String, default: '' },
    garage_id: { type: [String, Number], default: '' },
  },
  setup(props) {
    const personType = ref('natural')

    const form = reactive({
      user_id: '',
      name: '',
      last_name: '',
      email: '',
      phone: '',
      password: '',
      password_confirmation: '',
      term_conditions: false,
    })

    const company = reactive({
      company_name: '',
      ruc: '',
    })

    const submitV2 = async () => {
      // Validaciones mínimas solo para jurídica
      if (personType.value === 'juridica') {
        if (!company.company_name?.trim()) { 
          return customAlert({
            type: 'warning',
            message: 'Ingresa el nombre de la empresa.',
          })
        }
        if (!company.ruc || company.ruc.length !== 11) {
          return customAlert({
            type: 'warning',
            message: 'El RUC debe tener 11 dígitos.',
          })
        }
      }

      try {
        const body = {
          ...form,
          personType: personType.value,
          ...(personType.value === 'juridica'
            ? { company_name: company.company_name, ruc: company.ruc }
            : {}),
        }

        if (props.garage_id !== '' && props.garage_id !== null) {
          body.garage_id = props.garage_id
        }

        const { data } = await axios.post(props.url_signup, body)
           console.log(data);
        if (typeof data.id === 'number') {
          form.user_id = data.id

          if (
            data?.fb_pixel_data?.event_name &&
            data?.fb_pixel_data?.event_id
          ) {
           fbq(
              'track',
              data.fb_pixel_data.event_name,
              {},
              { eventID: data.fb_pixel_data.event_id }
            )
          }

         const loginRes = await axios.post(props.url_signin, body)
         customAlert(loginRes.data)
        } else {
          customAlert(data)
        }
      } catch (e) {
        console.error(e)
      }
    }

    return { personType, form, company, submitV2 }
  },
}
</script>
